import { FetchResult } from 'apollo-boost';

import {
    addCampaigns,
    deleteBrandLiftForCampaigns,
    findOrCreateExperimentsConditions,
    getOrCreateMetrikaGoalsForCampaignByCounter,
    updateCampaigns
} from '../../graphql/mutations/grid/campaigns';
import { CampaignId } from '../../typings/domain';
import {
    AddCampaigns,
    DeleteBrandLiftForCampaigns,
    FindOrCreateExperimentsConditions,
    GdAddCampaignUnionInput,
    GdCreateRetargetingConditionForExperimentsItemInput,
    GdUpdateCampaignUnionInput,
    GetOrCreateMetrikaGoalsByCounter,
    UpdateCampaigns
} from '../../typings/graphql-grid';
import { Omit } from '../../typings/utils';
import { BaseMutationExecutor } from '../BaseMutationExecutor/BaseMutationExecutor';

export class CampaignsMutationExecutor extends BaseMutationExecutor {
    public async updateCampaigns(
        inputItems: Omit<GdUpdateCampaignUnionInput, 'cpmPriceCampaign'>[],
        login: string
    ): Promise<FetchResult<UpdateCampaigns & { notSynced?: boolean }>> {
        return this.client.awaitMutate<UpdateCampaigns>({
            mutation: updateCampaigns,
            variables: {
                input: {
                    campaignUpdateItems: inputItems
                },
                login
            },
            login
        });
    }

    public async addCampaigns(
        inputItems: Omit<GdAddCampaignUnionInput, 'cpmPriceCampaign'>[],
        login: string
    ): Promise<FetchResult<AddCampaigns & { notSynced?: boolean }>> {
        return this.client.awaitMutate<AddCampaigns>({
            mutation: addCampaigns,
            variables: {
                input: {
                    campaignAddItems: inputItems
                },
                login
            },
            login
        });
    }

    public async findOrCreateExperimentsConditions(
        inputItems: GdCreateRetargetingConditionForExperimentsItemInput[],
        login: string
    ): Promise<FetchResult<FindOrCreateExperimentsConditions>> {
        return this.client.awaitMutate<FindOrCreateExperimentsConditions>({
            mutation: findOrCreateExperimentsConditions,
            variables: {
                input: {
                    items: inputItems
                },
                login
            },
            login
        });
    }

    public async getOrCreateMetrikaGoalsForCampaignByCounter(
        login: string,
        counterIds: string[],
        campaignId?: CampaignId
    ): Promise<FetchResult<GetOrCreateMetrikaGoalsByCounter>> {
        return await this.client.mutate<GetOrCreateMetrikaGoalsByCounter>({
            mutation: getOrCreateMetrikaGoalsForCampaignByCounter,
            variables: {
                input: {
                    campaignId,
                    counterIds
                },
                login
            }
        });
    }

    public async deleteBrandLiftForCampaigns(
        login: string,
        campaignIds: CampaignId[]
    ): Promise<FetchResult<DeleteBrandLiftForCampaigns>> {
        return this.client.awaitMutate<DeleteBrandLiftForCampaigns>({
            mutation: deleteBrandLiftForCampaigns,
            variables: {
                input: {
                    campaignIds
                },
                login
            },
            login
        });
    }
}
